import React, { useState } from "react";
import ProfileLayout from "../../components/layout/ProfileLayout";
import Settings from "./Setting";
import BillingSettings from "./BillingSettings";
import DeactivateAccount from "./DeactivateAccount";
import PasswordSettings from "./PasswordSettings";
import NotificationSettings from "./NotificationSettings";

const SettingPage = () => {
  const [activeSection, setActiveSection] = useState("password");

  return (
    <ProfileLayout>
      <div className="settings">
        <div className="settings-page">
          <Settings setActiveSection={setActiveSection} />
        </div>
        <div className="settings-main">
          {activeSection === "password" && <PasswordSettings />}
          {activeSection === "billing" && <BillingSettings />}
          {activeSection === "notifications" && <NotificationSettings />}
          {activeSection === "deactivate" && <DeactivateAccount />}
        </div>
      </div>
    </ProfileLayout>
  );
};

export default SettingPage;
